import {useState} from 'react'
import {IconButton, Link} from '@primer/react'
import {ShieldIcon, GitBranchIcon, ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'
import type {RuleConfig, RuleProvider} from '../types'
import {PanelList} from '@github-ui/panel-list'
import {RuleConfigFields} from './rule-config-fields'
import styles from './leading-icon-button.module.css'

export function RuleProviderRow({
  provider,
  fields,
}: {
  provider: RuleProvider
  fields: RuleConfig['parameterSchema']['fields']
}) {
  const [isExpanded, setIsExpanded] = useState(false)

  const hasFields = fields.length > 0
  const isActionsVisible = hasFields || provider.href

  return (
    <PanelList.Row key={`${provider.type}-${provider.name}`} className="tmp-ml-4">
      <PanelList.Row.LeadingVisual>
        <div className={`d-flex flex-row gap-1 ${styles.LeadingIconButtonContainer}`}>
          {hasFields && (
            <IconButton
              variant="invisible"
              onClick={() => setIsExpanded(!isExpanded)}
              icon={isExpanded ? ChevronDownIcon : ChevronRightIcon}
              aria-label={`${isExpanded ? 'Hide' : 'Show'} rule parameters`}
            />
          )}
          {provider.type === 'protected_branch' ? (
            <GitBranchIcon className="fgColor-muted my-2" aria-label="Branch protection provider" />
          ) : (
            <ShieldIcon className="fgColor-muted my-2" aria-label="Ruleset provider" />
          )}
        </div>
      </PanelList.Row.LeadingVisual>
      <strong>{provider.type !== 'protected_branch' ? provider.name : 'Branch protections'}</strong>
      {isActionsVisible && (
        <PanelList.Row.Actions>{provider.href ? <Link href={provider.href}>View</Link> : null}</PanelList.Row.Actions>
      )}
      {fields.length > 0 && isExpanded && (
        <PanelList.Row.Description>
          <RuleConfigFields fields={fields} provider={provider} />
        </PanelList.Row.Description>
      )}
    </PanelList.Row>
  )
}
